import React, { createContext, useContext } from 'react';

export const SnaiRunnerContext = createContext<boolean>(false);

const emptyContext = false;

export const useSnaiRunnerContext = () => {
  const selectSnaiRunnerContext = useContext(SnaiRunnerContext);
  return selectSnaiRunnerContext ?? emptyContext;
};